import create from 'zustand';

export type SyncModalType = 'install' | 'pasport' | 'replace';

export interface SyncModalVisibilityStore {
  isVisible: boolean;
  syncModalType?: SyncModalType;
  setState: (isVisible: boolean, syncModalType?: SyncModalType) => void;
}

export const useSyncModalStore = create<SyncModalVisibilityStore>(set => ({
  isVisible: false,
  syncModalType: undefined,
  setState: (isVisible, type) => {
    set({ isVisible, syncModalType: type || undefined });
  },
}));

export interface LogoutModalVisibilityStore {
  isVisible: boolean;
  setVisibility: (isVisible: boolean) => void;
}

export const useLogoutModalVisibilityStore = create<LogoutModalVisibilityStore>(set => ({
  isVisible: false,
  setVisibility: isVisible => {
    set({ isVisible });
  },
}));

export interface SettingsModalVisibilityStore {
  isVisible: boolean;
  setVisibility: (isVisible: boolean) => void;
}

export const useSettingsModalVisibilityStore = create<SettingsModalVisibilityStore>(set => ({
  isVisible: false,
  setVisibility: isVisible => {
    set({ isVisible });
  },
}));
